import { transformEmailThemeToBuilderUI } from "@circle-react/types/EmailTheme";
import { BuilderUI } from "@circle-react-shared/BuilderUI";
import { createBlockRendererMapping } from "@circle-react-shared/BuilderUI/Helpers/blockMappings";
import { BlockRenderer } from "@circle-react-shared/BuilderUI/Renderer/BlockRenderer";
import { blocks } from "../../VisualEmailBuilder/Blocks";
import { GooberContextProvider } from "../../VisualEmailBuilder/Design/GooberContext";
import { DEFAULT_THEME } from "../../VisualEmailBuilder/Design/defaultTheme";
import { EmailFrame } from "../../VisualEmailBuilder/EmailFrame";
import { useIsVisualEmailBuilderThemesEnabled } from "../../VisualEmailBuilder/hooks/useIsVisualEmailBuilderThemesEnabled";
import { useBroadcastPreviewContent } from "./useBroadcastPreviewContent";

const components = createBlockRendererMapping(blocks);

export const VisualBuilderPreviewContent = () => {
  const { visualEmailBuilderContent, emailTheme, isLoading } =
    useBroadcastPreviewContent();
  const isThemesEnabled = useIsVisualEmailBuilderThemesEnabled();

  if (isLoading || !visualEmailBuilderContent) {
    return null;
  }

  const theme =
    isThemesEnabled && emailTheme
      ? transformEmailThemeToBuilderUI(emailTheme)
      : DEFAULT_THEME;

  return (
    <BuilderUI.Provider
      theme={theme}
      block={visualEmailBuilderContent.content}
      inlineAttachments={visualEmailBuilderContent.inline_attachments}
      canvasSize="tablet"
    >
      <GooberContextProvider>
        <EmailFrame>
          <BlockRenderer
            components={components}
            block={visualEmailBuilderContent.content}
          />
        </EmailFrame>
      </GooberContextProvider>
    </BuilderUI.Provider>
  );
};
